import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {useParams} from 'react-router';
import SectionLayout from '../../../../CommonComponents/Layout/sectionLayout';
import CartConfirmationAction from '../../../../CommonComponents/CommonCartConfirmaton';
import {postJobPayment} from '../../../../../Store/Actions';
import JobCartTable from '../JobCartTable';
import {useNavigate} from 'react-router-dom';
import {validatePaymentPrice} from '../../../../../Util/commonUtility';
import NavigationComponent from '../../../../CommonComponents/CommonBackButton';
import useLocalization from '../../../../../Localization';

const NormalJobsCartComponent = ({jobData, jobFeesOptions}) => {
  const dispatch = useDispatch();
  const {ApplicationString} = useLocalization();
  const {id} = useParams();
  const navigate = useNavigate();
  const [isJobEditing, setISJobEditing] = useState();
  const handlePaymentClick = () => {
    if (validatePaymentPrice(jobData[0]?.job_fee, dispatch)) return;
    return dispatch(postJobPayment({jobsId: parseInt(id)}, navigate));
  };

  return (
    <div className='common-cart-container'>
      <div>
        <SectionLayout>
          <div className='common-cart-table-conatiner'>
            <NavigationComponent
              name={ApplicationString['userJobsComponent.goBackToJobPosting']}
              urlPath={`jobs`}
            />
            <JobCartTable
              jobsData={jobData}
              text={ApplicationString['userJobsComponent.pageName']}
              jobFeesOptions={jobFeesOptions}
              setISJobEditing={setISJobEditing}
            />
          </div>
          <div>
            <CartConfirmationAction
              heading={
                ApplicationString['userJobsComponent.totalAmountToBePaid']
              }
              price={jobData?.length > 0 && jobData[0]?.job_fee}
              onPay={handlePaymentClick}
              isJobEditing={isJobEditing}
            />
          </div>
        </SectionLayout>
      </div>
    </div>
  );
};

export default NormalJobsCartComponent;
